export default __webpack_public_path__ + "static/join-97859850a658b094f89da3331722ef74.svg";